
/*
 * GLOBAL THEME READY
 */
$(window).ready(function() {
    breakpoints();
    navSidebarScroll();
    asideCollapseAdjustView();
    aosInit();

});

/*
 * GLOBAL THEME WINDOW RESIZE
 */
$(window).resize(function() {
    breakpoints();
    navSidebarResize();
    asideCollapseAdjustView();
    AOS.refresh();
});


